import React from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import { useStaticQuery, graphql, withPrefix } from 'gatsby';

import { InitiativeCard } from './InitiativeCard';
import { CleanLink } from './common/CleanLink';
import {
  GraphQLNodeType,
  InitiativesModel,
  InitiativeRowSinglePropsModel,
} from '../types';

const InitiativeContainerListHome = styled.div``;

const InitiativeContainerListHomeRow = styled.div`
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem 1rem;
`;

const InitiativeCount = styled.div`
  margin-bottom: 1rem;
`;

type InitiativesHomeType = Pick<
  InitiativesModel,
  | 'IDInitiative'
  | 'NomInitiative'
  | 'DateCreationInitiative'
  | 'PiloteInitiative2'
  | 'EtatAffiche2'
  | 'DescListe'
  | 'ReferentCA2'
  | 'Thematiques'
  | 'OrigineInitiative'
  | 'EstActivite'
  | 'NbAppelsActifs'
>;
type dataQueryTypes = {
  InitiativeListHome: GraphQLNodeType<InitiativesHomeType>;
};

const InitiativeRowSingle = (props: InitiativeRowSinglePropsModel) => {
  const InitiativeRowStatus = props.status;
  const initiativeStateFilter = props.hiringFilter;
  const InitiativeRowNumber = props.number;
  const InitiativeRowText = props.text;

  const data_query = useStaticQuery<dataQueryTypes>(graphql`
    query InitiativeListHomeQuery {
      InitiativeListHome: allAirtable(
        filter: { table: { eq: "Initiatives" } }
        sort: { data: { DateCreationInitiative: DESC } }
      ) {
        edges {
          node {
            data {
              IDInitiative
              NomInitiative
              DateCreationInitiative
              PiloteInitiative2
              EtatAffiche2
              DescListe
              ReferentCA2
              Types
              Thematiques
              OrigineInitiative
              EstActivite
              NbAppelsActifs
            }
          }
        }
      }
    }
  `);

  const initiatives = data_query?.InitiativeListHome?.edges?.map((item) => {
    const data = item?.node?.data;

    const initiative = {
      id: data?.IDInitiative,
      name: data?.NomInitiative,
      creationDate: data?.DateCreationInitiative,
      // FIXME Status behavior differ slightly from types and thematiques,
      // we might want to harmonise them
      status: data?.EtatAffiche2?.[0],
      origin: data?.OrigineInitiative ?? '',
      description: data?.DescListe ?? '',
      pilote: data?.PiloteInitiative2 ?? '',
      thematiques: data?.Thematiques ?? [],
      isActivity: data?.EstActivite ?? 0,
      activeStaffingCount: data?.NbAppelsActifs ?? 0,
    };

    return initiative;
  });

  const start = 0;
  const end = InitiativeRowNumber;

  let filteredData = initiatives;

  if (InitiativeRowStatus) {
    filteredData = filteredData.filter((i) => i.status === InitiativeRowStatus);
  } else if (initiativeStateFilter) {
    filteredData = filteredData.filter((i) => i.activeStaffingCount > 0);
  }

  const filteredInitiativesCount = filteredData.length;

  const displayInitiatives = filteredData.slice(start, end);

  return (
    <InitiativeContainerListHome>
      <InitiativeCount>
        {filteredInitiativesCount} {InitiativeRowText}
      </InitiativeCount>
      <InitiativeContainerListHomeRow>
        {displayInitiatives.map((initiative) => {
          const creationDate = moment(initiative.creationDate);
          return (
            <CleanLink
              key={initiative.id}
              to={withPrefix(`/initiative/${initiative.id}`)}
            >
              <InitiativeCard
                title={initiative.name}
                creationDate={creationDate}
                origin={initiative.origin}
                status={initiative.status}
                pilote={initiative.pilote}
                shortDesc={initiative.description}
                types={initiative?.types}
                thematiques={initiative?.thematiques}
              />
            </CleanLink>
          );
        })}
      </InitiativeContainerListHomeRow>
    </InitiativeContainerListHome>
  );
};

export default InitiativeRowSingle;
